import { AboutPage } from "./About";
import { CareerPage } from "./Career";
import { ExperiencesPage } from "./Experiences";
import { SkillsPage } from "./Skills";
import { WorksPage } from "./Works";

const pages = {
    CareerPage,
    AboutPage,
    ExperiencesPage,
    SkillsPage,
    WorksPage
}
export default pages;